import { useEffect } from "react";
import { useTasks } from "../Hooks/useTasks";
import { AnimatePresence, motion } from "framer-motion";
import { ChartNoAxesGantt } from "lucide-react";
import { TASK_STATUS_MAPPING } from "../Constants";
import { useState } from "react";
import ManageTasks from "./ManageTasks";
import { Pagination, RoleValidator } from "../../../Components/Common";
import { ROLES } from "../../../Constants/Strings";
import TaskListCard from "./TaskListCard";

const SiteTasks = () => {
  const [isManageTaskOpen, setIsManageTaskOpen] = useState(false);

  const {
    loading,
    tasks,
    filters,
    setFilters,
    page,
    onPageChange,
    onPageSizeChange,
    totalPages,
    rowsPerPage,
    fetchTasksBySiteId,
  } = useTasks();

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
      fetchTasksBySiteId();
  }, [page, rowsPerPage, filters]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={"TASKS"}
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
        className="w-full overflow-hidden"
      >
        <div className="flex items-center justify-between gap-6 mb-4 px-2 w-full">
          <h3 className="text-lg font-semibold text-primary pb-1">
            Site Tasks
          </h3>
          <div className="flex items-center justify-between gap-6">
            <div className="border-b-2 border-gray-500">
              <select
                name="status"
                value={filters?.status || ""}
                onChange={(e) => handleFilterChange(e)}
                className="appearance-none border-none border-b-2 border-gray-300 px-2 py-1 text-sm focus:outline-none focus:border-none"
              >
                {TASK_STATUS_MAPPING.map((status, index) => (
                  <option key={index} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="relative group">
              <RoleValidator
                allowedRoles={[
                  ROLES.MANAGING_DIRECTOR,
                  ROLES.HEAD_OFFICE,
                  ROLES.GOVERNMENT_OFFICER,
                  ROLES.PROJECT_MANAGER,
                ]}
                mode="disable"
              >
                <button className="bg-[#47a2f7] text-white px-2 py-1 rounded-md hover:bg-primary max-h-fit cursor-pointer">
                  <ChartNoAxesGantt onClick={() => setIsManageTaskOpen(true)} />
                </button>
              </RoleValidator>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 text-xs text-white bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                Manage Task
                <div className="absolute left-1/2 -bottom-1 transform -translate-x-1 w-2 h-2 bg-gray-700 rotate-45"></div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center h-[150px]">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500"></div>
          </div>
        ) : tasks.length === 0 ? (
          <p>No tasks found for this site.</p>
        ) : (
          <>
            <div className="pl-5 pr-1 h-[56vh] md:h-[48vh] overflow-y-auto w-full">
              <TaskListCard tasks={tasks} />
            </div>
            <Pagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
              totalPages={totalPages}
            />
          </>
        )}
        {isManageTaskOpen && (
          <ManageTasks
            onclose={() => {
              setIsManageTaskOpen(false);
              fetchTasksBySiteId();
            }}
          />
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default SiteTasks;
